import { useMemo } from 'react';

import { getFilterOptions } from '../../helpers/filter';

import { BLANK_FILTER_TEXT } from '../../constants/livestock';

function getMatchingUnits(arr1, arr2) {
  const dosageUoms = new Set();
  let hasBlank = false;

  for (const item of arr2) {
    const uom = item.dosage_uom;
    if (uom === null || uom === undefined || uom === '') {
      hasBlank = true;
    } else {
      dosageUoms.add(uom);
    }
  }

  const seen = new Set();
  const result = arr1.filter(({ value }) => {
    if (dosageUoms.has(value) && !seen.has(value)) {
      seen.add(value);
      return true;
    }
    return false;
  });

  if (hasBlank) {
    result.push({ value: BLANK_FILTER_TEXT, text: BLANK_FILTER_TEXT });
  }

  return result.sort((a, b) => a.text.localeCompare(b.text));
}

export const useFilterOptions = ({ data, treatmentUOMFilterOptions }) => {
  return useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) {
      return {
        breeds: [],
        sex: [],
        treatmentTypes: [],
        uom: []
      };
    }

    return {
      breeds: getFilterOptions(data, 'breed'),
      sex: getFilterOptions(data, 'sex'),
      treatmentTypes: getFilterOptions(data, 'treatment_type_name'),
      uom: getMatchingUnits(treatmentUOMFilterOptions, data)
    };
  }, [data, treatmentUOMFilterOptions]);
};
